var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVistaVaciaFormaDePago(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 149.05 124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:1;}.cls-2{fill:#05365b;}.cls-3{fill:#008c61;}.cls-4{fill:#e29d81;}.cls-5{fill:#d3856a;}.cls-6{fill:#fff;}.cls-7{fill:#dfe2e5;}.cls-8{fill:#006d49;}.cls-9{fill:#f9bda0;}.cls-10{fill:#ffe4c7;}.cls-11{fill:#00263d;}.cls-12{fill:#ffc114;}.cls-13{fill:#e8ab92;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 23otros") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WEB_VIEW",
    "data-name": "WEB VIEW"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "0 0 0 1.2 0 71.16 10.58 77.89 42.79 27.16 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "149.05 1.2 149.05 0 106.26 27.16 138.47 77.89 149.05 71.16 149.05 1.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M121.4,88.23c9.14-5.77,11.54-18.27,5.29-27.89l-7.69-12c-6.25-9.62-18.51-12.74-27.65-7L64,58.66c-9.14,5.77-11.54,18.27-5.29,27.88l7.69,12c6.25,9.62,18.51,12.75,27.65,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M118,90.39a7.35,7.35,0,0,0,2.16-10.1h0a7.35,7.35,0,0,0-10.1-2.16l-50.48,32a7.34,7.34,0,0,0-2.16,10.1h0a7.32,7.32,0,0,0,10.09,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M58.9,86.54l7.69,12c6.25,9.62,18.51,12.75,27.65,7l27.4-17.31c9.14-5.77,11.54-18.27,5.29-27.89l-7.69-12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M86.78,78.61A7.35,7.35,0,0,0,89,68.51h0a7.35,7.35,0,0,0-10.1-2.16L28.37,98.56a7.35,7.35,0,0,0-2.17,10.1h0a7.35,7.35,0,0,0,10.1,2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M97.36,88.23a7.35,7.35,0,0,0,2.17-10.1h0A7.34,7.34,0,0,0,89.43,76L39,108.18a7.35,7.35,0,0,0-2.17,10.1h0a7.35,7.35,0,0,0,10.1,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M86.54,62a7.34,7.34,0,0,0,2.17-10.09h0a7.35,7.35,0,0,0-10.1-2.17L28.13,82A7.34,7.34,0,0,0,26,92.07h0a7.35,7.35,0,0,0,10.1,2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M96.64,39S68.27,43,65.87,43.75c-2.16.72-8.89,17.07-1.2,19,7.93,1.93,20.43-8.17,20.43-8.17Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 116.81,
    y: 28.26,
    width: 8.9,
    height: 51.93,
    transform: "translate(-10.16 73.53) rotate(-32.45)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "111.07 30.05 103.61 34.86 131.5 78.61"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "149.05 0 106.26 27.16 138.47 77.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M120.68,98.32l-4.57-2.88a7.43,7.43,0,0,0,7-3.37A7.34,7.34,0,0,0,120.92,82L87.27,60.58c2.4-5-2.41-15.87-4.09-16.59-2.16-.72-28.13-4.32-30.53-4.8-8.18-2.41-17.55,1.2-22.6,9.13l-7.69,12C16.11,70,18.51,82.46,27.65,88.23l2.16,1.44a5.24,5.24,0,0,0,1.2,1L81.5,122.85a7.34,7.34,0,0,0,10.09-2.17,6.7,6.7,0,0,0,.72-6l9.62,6.25a7.34,7.34,0,0,0,10.1-2.16,6.9,6.9,0,0,0,0-7.69l.48.24a7.34,7.34,0,0,0,10.09-2.17C125.25,105.06,124.29,100.49,120.68,98.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M83.9,120a2.86,2.86,0,0,1-1-4.09l1-1.68a2.86,2.86,0,0,1,4.09-1h0a2.86,2.86,0,0,1,1,4.09L88,119a2.82,2.82,0,0,1-4.09,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M115.15,108.18a2.86,2.86,0,0,1-1-4.09l1-1.68a2.86,2.86,0,0,1,4.09-1h0a2.86,2.86,0,0,1,1,4.09l-1,1.68a2.82,2.82,0,0,1-4.09,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M104.57,117.8a2.86,2.86,0,0,1-1-4.09l1-1.68a2.85,2.85,0,0,1,4.09-1h0a2.85,2.85,0,0,1,1,4.08l-1,1.69a2.86,2.86,0,0,1-4.09,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M115.39,91.83a2.85,2.85,0,0,1-1-4.08l1-1.69a2.86,2.86,0,0,1,4.09-1h0a2.86,2.86,0,0,1,1,4.09l-.72,1.68a3.38,3.38,0,0,1-4.33,1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1.77,
    y: 49.88,
    width: 51.93,
    height: 8.89,
    transform: "translate(-32.99 48.58) rotate(-57.55)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "37.98 30.05 45.44 34.86 17.55 78.61"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-11",
    points: "0 0 42.79 27.16 10.58 77.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M16.83,46.16A4.77,4.77,0,0,1,10.1,47.6a4.87,4.87,0,1,1,5.29-8.17A5,5,0,0,1,16.83,46.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M120.92,81.74,87.27,60.34c2.4-5.05-2.41-15.87-4.09-16.59-1-.48-7.69-1.44-14.67-2.4l-7.69,24,63.23,20.19A6.84,6.84,0,0,0,120.92,81.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M89,45.44c2.16,3.6,3.12,13,.24,14.66L64.91,65.39C62,67.07,58.18,65.39,56,62h0c-2.16-3.6-1.44-7.69,1.45-9.37l17.3-10.1c2.89-1.68,11.78-1.2,13.95,2.16Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVistaVaciaFormaDePago);
export default __webpack_public_path__ + "static/media/vista-vacia-forma-de-pago.864095df6d7f3110c5b7646bad1b9072.svg";
export { ForwardRef as ReactComponent };